import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { mergeMap, catchError } from 'rxjs/operators';
import { of, throwError, Observable } from 'rxjs';
import { AssignmentGroup } from '../types/assignments.types';

@Injectable()
export class AssignmentGroupsService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.apiHost = config.params['apiHost'];
  }
  private apiHost;

  public getGroups(): Observable<AssignmentGroup[]> {
    const url = `${this.apiHost}/v1/assignment-groups`;

    return this.http.get(url, { observe: 'response' }).pipe(
      mergeMap((res: HttpResponse<any>) => {
        const data = res.status === 200 || res.status === 204;
        return data
          ? of((res.body || []).map(this.mapper.bind(this)))
          : throwError('Error getting assignments');
      })
    );
  }

  public saveGroup(
    assignmentGroup: AssignmentGroup
  ): Observable<AssignmentGroup> {
    const url = `${this.apiHost}/v1/assignment-groups`;

    return this.http.post(url, assignmentGroup, { observe: 'response' }).pipe(
      mergeMap((res: HttpResponse<any>) => {
        const success = res.status === 200 && res.body;
        return success ? of(this.mapper(res.body)) : this.error(res);
      }),
      catchError(e => {
        const message =
          e.status === 409 ||
          (e.error && e.error.error && e.error.error.startsWith('409'))
            ? 'Custom Group name already exists.'
            : 'Generic group save error.';
        return throwError(message);
      })
    );
  }

  public deleteGroup(assignmentGroupId: string) {
    const url = `${this.apiHost}/v1/assignment-groups/${assignmentGroupId}`;

    return this.http.delete(url, { observe: 'response' }).pipe(
      mergeMap((res: HttpResponse<any>) => {
        const success = res.status === 200;
        return success ? of({}) : this.error(res);
      })
    );
  }

  private error(res) {
    return throwError({ type: res.body.type, title: res.body.title });
  }

  private mapper(assignmentGroup) {
    return {
      ...assignmentGroup,
      users: assignmentGroup.users.map(u => u.userId)
    } as AssignmentGroup;
  }
}
